import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M5 8h2v8H5zm7 0H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6h-1v-4h1v4zm7-6h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6h-1v-4h1v4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 4v16h20V4H2zm2 14V6h16v12H4z"
})), 'Money');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Money.js
// module id = 4881
// module chunks = 2